import React from 'react'
import loadable from '@loadable/component'

import classNames from 'classnames'
import Markdown from 'markdown-to-jsx'
import Image from '../Image'
import styles from './contact-testimonials.module.sass'

// import TestimonialCarousel from '../Blocks/TestimonialCarousel'
const LazyTestimonialCarousel = loadable(() => import('../Blocks/TestimonialCarousel'))
const TestimonialCarousel = props => <LazyTestimonialCarousel {...props} />

export default function ContactTestimonials({ header, classes }) {
  return (
    <section className={classNames(styles.contactTestimonials, classes)}>
      {header && (
        <header className={styles.sectionHeader}>
          <div className="container">
            <Markdown children={header.text} />
          </div>
        </header>
      )}
      <div className={styles.sectionContent}>
        <div className="container">
          <TestimonialCarousel />
        </div>
      </div>
      <Image className={styles.sectionBg} wrapper src="/images/backgrounds/testimonial-carousel-bg.svg" />
    </section>
  )
}
